import { createContext } from 'react';

export const OrgContext = createContext(
  {
    currentOrg: null,
    setCurrentOrg: () => { },
  }
);